import { useQuery } from "@tanstack/react-query";
import type { NcDto, Page } from "@audit-plan/shared";
import { api } from "./client";
import { unwrap } from "./audits";

export type NcFilters = { q?: string; severity?: string; status?: string; supplierId?: string; factoryId?: string; auditId?: string };

export function useNcs(f: NcFilters = {}) {
  return useQuery({ queryKey: ["ncs", "b", f], queryFn: async () => unwrap(await api.get<NcDto[] | Page<NcDto>>("/ncs", f)) });
}

export function useNc(id?: string | null) {
  return useQuery({ queryKey: ["nc", id], queryFn: () => api.get<NcDto>(`/ncs/${id}`), enabled: !!id });
}
